import { useContext } from 'react';
import { DragPreviewContext } from './DragPreviewContext';
function callAllCallbacks(fns) {
  fns.forEach(fn => {
    fn();
  });
}
class DragPreviewManager {
  constructor({
    dragPreviewZIndex,
    dragPreviewPosition
  }) {
    this.subscribers = new Set();
    this.dragPreviewZIndex = dragPreviewZIndex;
    this.dragPreviewPosition = dragPreviewPosition;
  }
  static getInstance() {
    if (!DragPreviewManager.instance) {
      throw new Error('DragPreviewManager not initialized');
    }
    return DragPreviewManager.instance;
  }
  static initialize(dragPreviewZIndex, dragPreviewPosition) {
    DragPreviewManager.instance = new DragPreviewManager({
      dragPreviewZIndex,
      dragPreviewPosition
    });
    return DragPreviewManager.instance;
  }
  setDragPreviewZIndex(dragPreviewZIndex) {
    this.dragPreviewZIndex = dragPreviewZIndex;
    this.__notifySubscribers();
  }
  setDragPreviewPosition(dragPreviewPosition) {
    this.dragPreviewPosition = Object.assign({}, this.dragPreviewPosition, dragPreviewPosition);
    this.__notifySubscribers();
  }
  getDragPreviewZIndex() {
    return this.dragPreviewZIndex;
  }
  getDragPreviewPosition() {
    return this.dragPreviewPosition;
  }
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }
  __notifySubscribers() {
    callAllCallbacks(this.subscribers);
  }
}
export default DragPreviewManager;
export function useDragPreviewManager() {
  const {
    dragPreviewManager
  } = useContext(DragPreviewContext);
  if (!dragPreviewManager) {
    throw new Error('DragPreviewManager not initialized');
  }
  return dragPreviewManager;
}